import { DeactivateSubaccountRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

// Direct-Pattern reimplementation of client-dashboard's legacy useDeactivateSubAccount (ID-13193), on the
// host-injected api via useApi(); no CancelToken. A pure mutation — nothing stored, no fetching flag (the
// consuming component raises the blocking loader; loading-conventions).
export default function useDeactivateSubAccount() {
  const api = useApi();

  async function deactivateSubaccount(request: DeactivateSubaccountRequest) {
    try {
      const res = await api.deactivateSubaccount(request);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { deactivateSubaccount };
}
